<h3>{{ 'comments' | translate }}</h3>
<div>
  @if (canAddComment) {
    <app-comment-input
      [entityId]="entityId"
      [entityType]="entityType"
      [privilege]="privilege"
      [isInPopup]="isInPopup"
    ></app-comment-input>
  }

  <app-comments-list
    #commentsListComponent
    [entityId]="entityId"
    [entityType]="entityType"
    [isInPopup]="isInPopup"
    [adminPrivilege]="adminPrivilege"
    [showDeleteButton]="showDeleteButton"
  ></app-comments-list>
</div>
